import { Plus } from 'lucide-react';
import EmptyButton from 'ud-ui/components/empty-button';

// import PlusIcon from 'ud-ui/components/icon/plus-icon';

interface IProps {
  showAddNewBoard?: boolean;
}

function LeftMenuSkeleton(props: IProps) {
  const { showAddNewBoard = false } = props;
  return (
    <div className="flex flex-col gap-5">
      <div className="skeleton-block" style={{ width: 260, height: 436 }} />
      {showAddNewBoard && (
        <EmptyButton color={'#A2A2A2'} icon={<Plus size={16} />} disabled>
          Добавить табло
        </EmptyButton>
      )}
    </div>
  );
}

export default LeftMenuSkeleton;
